import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState } from 'react'
import ReactGA from 'react-ga4'
import { faq } from '../data/faq'

export default function Faq() {
  const [expanded, setExpanded] = useState<Record<string, boolean>>({})

  const toggle = (id: number) => {
    const key = String(id)
    setExpanded((prev) => ({
      ...prev,
      [key]: !prev[key],
    }))
  }

  return (
    <section
      id="faq"
      className="container-responsive cv-auto rounded-t-none bg-gray-200 py-8 dark:bg-gray-800 sm:py-12 xl:rounded-t-lg"
    >
      <div className="mb-6 flex items-end justify-between">
        <h2 className="text-xl font-semibold tracking-tight sm:text-2xl">
          Frequently Asked Questions
        </h2>
      </div>
      <div className="divide-y divide-neutral-200 dark:divide-gray-600">
        {faq.map((item) => (
          <details
            key={item.id}
            className={[
              'group cursor-pointer p-4 hover:bg-neutral-50 dark:hover:bg-gray-900',
              expanded[String(item.id)]
                ? 'bg-neutral-50 dark:bg-gray-900'
                : 'backdrop-blur-md',
            ].join(' ')}
            onClick={(e) => {
              e.preventDefault()
              toggle(item.id)
              ReactGA.event({
                category: 'Button Click',
                action: `User clicked the question: ${item.question}`,
                label: 'FAQ Section',
              })
            }}
            open={expanded[String(item.id)]}
          >
            <summary className="flex cursor-pointer list-none items-center justify-between gap-4">
              <span className="text-base font-medium hover:underline">
                {item.question}
              </span>
              <span className="select-none text-xl leading-none transition-transform duration-500 ease-in-out group-open:rotate-45">
                <FontAwesomeIcon icon={faPlus} />
              </span>
            </summary>
            <div className="mt-3 text-neutral-600 dark:text-neutral-300">
              {typeof item.answer === 'string' ? (
                item.answer
              ) : (
                // eslint-disable-next-line react-dom/no-dangerously-set-innerhtml
                <div dangerouslySetInnerHTML={item.answer} />
              )}
            </div>
          </details>
        ))}
      </div>
    </section>
  )
}
